import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

if (env === 'production') {
    LogRocket.init('yg50r9/24-drukwerk', {
        release: VERSION,
    });
    if (user_id.trim() !== 'not_logged_in') {
        LogRocket.identify(user_id, {
            email: USER_EMAIL,
        });
    }
    setupLogRocketReact(LogRocket);
}

require('../React/Old/Components/ProductOptions/ProductOptions');

